import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { Link } from "react-router-dom";
import SpeakingZone from "assets/images/images_new/microphone-icon.svg";
import WritingZone from "assets/images/images_new/writing-icon.svg";
import ReadingZone from "assets/images/images_new/reading-icon.svg";
import ListeningZone from "assets/images/images_new/listening-icon.svg";
import ChartImg from "assets/images/images_new/chart.png";
import MicrophoneIcon from "assets/images/images_new/headset-icon.png";
import { BsArrowRightShort } from "react-icons/bs";
import NoData from "assets/images/no-data.svg"

export default function EstimatedExamScore({ estimatedScore, sectional_estimated }) {


  const data = [
    {
      name: "Speaking",
      value: sectional_estimated?.speaking?.score || 0,
      percentage: sectional_estimated?.speaking?.percentage || 0,
      color: "#1E90FF",
      icon: <img src={SpeakingZone} alt="" srcSet="" />,
      border : "#1E90FF"
    },
    {
      name: "Writing",
      value: sectional_estimated?.writing?.score || 0,
      percentage: sectional_estimated?.writing?.percentage || 0,
      color: "#7CFC00",
      icon: <img src={WritingZone} alt="" srcSet="" />,
      border : "#7CFC00"
    },
     {
      name: "Reading",
      value: sectional_estimated?.reading?.score || 0,
      percentage: sectional_estimated?.reading?.percentage || 0,
      color: "#FFA500",
      icon: <img src={ReadingZone} alt="" srcSet="" />,
      border : "#FFA500"
    },
    {
      name: "Listening",
      value: sectional_estimated?.listening?.score || 0,
      percentage: sectional_estimated?.listening?.percentage || 0,
      color: "#9370DB",
      icon: <img src={ListeningZone} alt="" srcSet="" />,
      border : "#9370DB"
    },
   
  ];

  const totalScore = data.reduce((acc, item) => acc + item.value, 0);
  const averageScore = Math.round(totalScore / data.length);
  return (
    <div id="tour-exam-btn" className="col-md-6 col-xl-6 pr-md-0 row flex-md-wrap">
      <div className="dashboard-card dashboard-score-card col-md-12 ">
        {/* <h2 className="title text-center">AI Estimated Exam Score</h2> */}
        <h2 className="title text-center d-inline-flex align-items-center justify-content-center gap-2 w-100">
  <span className="position-relative">
    AI Estimated Exam Score
    <span className="info-icon-wrapper ai-estimated">
    <i className="bi bi-info-circle-fill info-icon"></i>
    <span className="custom-tooltip" style={{
      maxWidth: "150px",
      right: "-91px",
      top : "35px",
      left: "auto",
      transform: "translateX(0)",
      whiteSpace: "normal"
    }}>
     The score is based on the performance of the last three full mock tests.
    </span>
  </span>
    </span>
  
</h2>
        <div className="estimated-card-content">
          {!estimatedScore || estimatedScore === "N/A" ? (
            <div className="text-center p-4 w-100">
              <img src={NoData} alt="No Data Found"/>
              <p className="mb-3" style={{ fontSize: "14px", color: "#666", fontWeight: "400", lineHeight: "1.6" }}>
                No data available yet. Complete a Full mock test to see your
                estimated score.
              </p>
              <div className="stats-btns border-0 p-0 m-0 d-flex justify-content-center">
                <Link
                  to="/admin/mock"
                  className="stats-btn px-4"
                  style={{ backgroundColor: "#093330", color: "#ffffff", borderColor: "#093330" }}
                >
                  Take Test
                </Link>
              </div>
            </div>
          ) : (
            <div
              style={{
                padding: "20px",
                border: "1px solid #eee",
                borderRadius: "12px",
                fontFamily: "Arial, sans-serif",
                display:"flex",
                flexDirection:"column-reverse",
                gap: "10px",
              }}
              className="scroeCardSection"
            >
              {/* Label and icons left wale*/}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "10px",
                  width:"100%"
                }}
                className="scoreProgressList"
              >
                {data.map((item) => (
                  <div
                    key={item.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#F6F6F7",
                      padding: "10px",
                      borderRadius: "10px",
                      justifyContent: "space-between",
                      border: `1px solid ${item.border  }`
                    }}
                  >
                    <div
                      style={{
                        fontSize: "20px",
                        color: item.color,
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px"
                      }}
                    >
                      {item.icon}
                      <p className="mb-0" style={{ color: "black", fontSize: "11px" }}>{item?.name}</p>
                    </div>
                    <div>{item.value}</div>
                  </div>
                ))}
              </div>
              {/* <style>{`
                @media (max-width: 991px) {
                  .scoreProgressList {
                    grid-template-columns: 1fr !important;
                  }
                }
              `}</style> */}

              {/* Chart Div */}
              <div style={{ position: "relative", height: "200px", width: "100%" }}>
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={data}
                      dataKey="value"
                      innerRadius={55}
                      outerRadius={80}
                      startAngle={90}
                      endAngle={-270}
                      paddingAngle={3}
                      cornerRadius={5}
                      stroke="none"
                      cx="50%"
                      cy="50%"
                    >
                      {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>

                {/* Center value div */}
                <div
                  style={{
                    position: "absolute",
                    borderRadius: "50%",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    textAlign: "center",
                    backgroundColor: "#F6F6F7",
                    width: "92px",
                    height: "92px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {/* <div style={{ fontSize: "14px", color: "#888" }}>
                    Average Score
                  </div> */}
                  <div style={{ fontSize: "28px", fontWeight: "bold" }}>
                    {estimatedScore ? estimatedScore : "N/A"}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* {
        !estimatedScore && (
       <div className="dashboard-card microphone-card col-md-5 position-relative relative d-flex w-100 flex-column">
        <h2 className="title">Microphone Setup</h2>
        <div className="microphone-card-content">
          <img src={MicrophoneIcon} alt="Microphone Setup" />
        </div>
        <Link className="microphone-link" to="/admin/mic-setup"></Link>
      </div>
        )
      } */}
    {/* {
        !estimatedScore && (
       <div className="dashboard-card microphone-card col-md-5 d-flex w-100 align-items-center">
        <h2 className="title m-0">Microphone Setup</h2>
        <Link className="primary-btn text-center" to="/admin/mic-setup">Test Mic <BsArrowRightShort fontSize={"20px"}/></Link>
      </div>
        )
      } */}
    </div >
  );
}
